import React, { Component } from 'react';
import { Input, Radio } from '../../../common/components/formControls';
import { Form, Panel, Row, Col } from 'react-bootstrap';
import { Field } from 'redux-form';
import withResourcesNamespace from '../../../common/components/withResourcesNamespace';
import validators from '../../../common/services/validators';
import { connect } from 'react-redux';
import { fetchChildDetails } from './actions';

const yesNoOptions = (t) => {
	return [
		{ value: 'true', label: t('Yes') },
		{ value: 'false', label: t('No') }
	];
};

const parseBoolean = value => value === 'true' ? true : false;

class CoreStabilityAssessment extends Component {
	componentDidMount() {
		this.props.fetchChildDetails(this.props.childId);
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.currentFormValues) {
			const calculatedFields = this.getCalculatedFields(nextProps.currentFormValues, nextProps.child);
			Object.keys(calculatedFields).forEach(field => {
				const nextValue = calculatedFields[field];
				if (this.props.currentFormValues[field] !== nextValue) {
					this.props.changeFormValue(field, nextValue);
				}
			});
		}
	}

	getCalculatedFields(formValues, child) {
		const gender = child && child.melilloDetails && child.melilloDetails.gender;

		let calculatedFields = {};

		calculatedFields = Object.assign(calculatedFields, this.calculateLevel(formValues, bridgePositionLevels, 'bridgePositionLevel', 'bridgePositionTime'));
		calculatedFields = Object.assign(calculatedFields, this.calculateLevel(formValues, curlUpsLevels, 'curlUpsLevel', 'curlUpsCount'));
		calculatedFields = Object.assign(calculatedFields, this.calculateLevel(formValues, lateralCoreLevels, 'lateralCoreLevel', 'lateralCoreTime'));
		calculatedFields = Object.assign(calculatedFields, this.calculateLevel(formValues, proneCoreLevels, 'proneCoreLevel', 'proneCoreTime'));
		calculatedFields = Object.assign(calculatedFields, this.calculateLevel(formValues, aerobicExerciseLevels, 'aerobicExerciseLevel'));
		calculatedFields = Object.assign(calculatedFields, this.calculateLevel(formValues, postrotatoryNystagmusLevels, 'postrotatoryNystagmusLevel'));

		if (gender) {
			calculatedFields = Object.assign(calculatedFields, this.calculateLevel(formValues, gender === 'male' ? pushUpsBoyLevels : pushUpsGirlLevels, 'pushUpsLevel', 'pushUpsValue'));
			calculatedFields = Object.assign(calculatedFields, this.calculateLevel(formValues, gender === 'male' ? brachiationBoyLevels : brachiationGirlLevels, 'brachiationLevel'));
		}
		else {
			calculatedFields['pushUpsLevel'] = 'N/A';
			calculatedFields['pushUpsValue'] = null;
			calculatedFields['brachiationLevel'] = 'N/A';
		}

		return calculatedFields;
	}

	calculateLevel(values, levels, levelField, levelValueField) {
		let currentLevel = 0;
		let currentLevelValue = 0;

		for (let level of levels) {
			if (level.calculateFunc && level.calculateFunc(values[level.field]) || level.minValue && (values[level.field] >= level.minValue)) {
				currentLevel = level.level;
				currentLevelValue = values[level.field];
				break;
			}
		}

		const result = {
			[levelField]: currentLevel
		};
		if (levelValueField) {
			result[levelValueField] = currentLevelValue;
		}
		return result;
	}

	render() {
		const { t, isReadOnly } = this.props;

		const colSize = { labelCol: 6, valueCol: 2 };
		const totalColSize = { labelCol: 6, valueCol: 4 };

		const descriptionStyle = {
			marginBottom: '10px'
		};

		const attentionStyle = {
			marginBottom: '5px',
			color: 'red'
		};

		const bridgePosition = [...Array(12).keys()]
			.map(x => <Field name={`bridgePosition_${x + 1}`} component={Input} horizontal label={t(`BridgePosition_${x + 1}`)} parse={value => value && Number(value)} disabled={isReadOnly} {...colSize} validate={validators.number} />);
		const curlUps = [...Array(2).keys()]
			.map(x => <Field name={`curlUps_${x + 1}`} component={Input} horizontal label={t(`CurlUps_${x + 1}`)} parse={value => value && Number(value)} disabled={isReadOnly} {...colSize} validate={validators.number} />);
		const lateralCore = [...Array(6).keys()]
			.map(x => <Field name={`lateralCore_${x + 1}`} component={Input} horizontal label={t(`LateralCore_${x + 1}`)} parse={value => value && Number(value)} disabled={isReadOnly} {...colSize} validate={validators.number} />);
		const proneCore = [...Array(11).keys()]
			.map(x => <Field name={`proneCore_${x + 1}`} component={Input} horizontal label={t(`ProneCore_${x + 1}`)} parse={value => value && Number(value)} disabled={isReadOnly} {...colSize} validate={validators.number} />);
		const pushUps = [...Array(2).keys()]
			.map(x => <Field name={`pushUps_${x + 1}`} component={Input} horizontal label={t(`PushUps_${x + 1}`)} parse={value => value && Number(value)} disabled={isReadOnly} {...colSize} validate={validators.number} />);
		const postrotatoryNystagmus = [...Array(5).keys()]
			.map(x => <Field name={`postrotatoryNystagmus_${x + 1}`} component={Radio} entries={yesNoOptions(t)} parse={parseBoolean} inline horizontal label={t(`PostrotatoryNystagmus_${x + 1}`)} disabled={isReadOnly} {...colSize} />);

		return (
			<Form >
				<div style={attentionStyle}>
					<h4>{t('Attention')}</h4>
					<ul>
						<li>{t('Attention_1')}</li>
						<li>{t('Attention_2')}</li>
					</ul>
				</div>
				<Panel>
					<Panel.Heading>{t('BridgePosition')}</Panel.Heading>
					<Panel.Body>
						<div style={descriptionStyle}>{t('BridgePosition_Description')}</div>
						{bridgePosition}
						<Row>
							<Col sm={6}>
								<Field name='bridgePositionLevel' component={Input} horizontal type='text' label={t('Level')} {...totalColSize} disabled />
							</Col>
							<Col sm={6}>
								<Field name='bridgePositionTime' component={Input} horizontal type='text' label={t('Time')} {...totalColSize} disabled />
							</Col>
						</Row>
					</Panel.Body>
				</Panel>
				<Panel>
					<Panel.Heading>{t('CurlUps')}</Panel.Heading>
					<Panel.Body>
						{curlUps}
						<Row>
							<Col sm={6}>
								<Field name='curlUpsLevel' component={Input} horizontal type='text' label={t('Level')} {...totalColSize} disabled />
							</Col>
							<Col sm={6}>
								<Field name='curlUpsCount' component={Input} horizontal type='text' label={t('Count')} {...totalColSize} disabled />
							</Col>
						</Row>
					</Panel.Body>
				</Panel>
				<Panel>
					<Panel.Heading>{t('LateralCore')}</Panel.Heading>
					<Panel.Body>
						<div style={descriptionStyle}>{t('LateralCore_Description')}</div>
						{lateralCore}
						<Row>
							<Col sm={6}>
								<Field name='lateralCoreLevel' component={Input} horizontal type='text' label={t('Level')} {...totalColSize} disabled />
							</Col>
							<Col sm={6}>
								<Field name='lateralCoreTime' component={Input} horizontal type='text' label={t('Time')} {...totalColSize} disabled />
							</Col>
						</Row>
					</Panel.Body>
				</Panel>
				<Panel>
					<Panel.Heading>{t('ProneCore')}</Panel.Heading>
					<Panel.Body>
						<div style={descriptionStyle}>{t('ProneCore_Description')}</div>
						{proneCore}
						<Row>
							<Col sm={6}>
								<Field name='proneCoreLevel' component={Input} horizontal type='text' label={t('Level')} {...totalColSize} disabled />
							</Col>
							<Col sm={6}>
								<Field name='proneCoreTime' component={Input} horizontal type='text' label={t('Time')} {...totalColSize} disabled />
							</Col>
						</Row>
					</Panel.Body>
				</Panel>
				<Panel>
					<Panel.Heading>{t('PushUps')}</Panel.Heading>
					<Panel.Body>
						{pushUps}
						<Row>
							<Col sm={6}>
								<Field name='pushUpsLevel' component={Input} horizontal type='text' label={t('Level')} {...totalColSize} disabled />
							</Col>
							<Col sm={6}>
								<Field name='pushUps_1' component={Input} horizontal type='text' label={t('Time')} {...totalColSize} disabled />
							</Col>
						</Row>
					</Panel.Body>
				</Panel>
				<Panel>
					<Panel.Heading>{t('Brachiation')}</Panel.Heading>
					<Panel.Body>
						<Field name='brachiation_1' component={Radio} horizontal label={t('Brachiation_1')} entries={yesNoOptions(t)} parse={parseBoolean} inline disabled={isReadOnly} {...colSize} />
						<Field name='brachiation_2' component={Radio} horizontal label={t('Brachiation_2')} entries={yesNoOptions(t)} parse={parseBoolean} inline disabled={isReadOnly} {...colSize} />
						<Field name='brachiation_3' component={Input} horizontal label={t('Brachiation_3')} parse={value => value && Number(value)} disabled={isReadOnly} {...colSize} validate={validators.number} />
						<Row>
							<Col sm={6}>
								<Field name='brachiationLevel' component={Input} horizontal type='text' label={t('Level')} {...totalColSize} disabled />
							</Col>
						</Row>
					</Panel.Body>
				</Panel>
				<Panel>
					<Panel.Heading>{t('AerobicExercise')}</Panel.Heading>
					<Panel.Body>
						<Field name='aerobicExercise_1' component={Radio} horizontal label={t('AerobicExercise_1')} entries={yesNoOptions(t)} parse={parseBoolean} inline disabled={isReadOnly} {...colSize} />
						<Field name='aerobicExercise_2' component={Radio} horizontal label={t('AerobicExercise_2')} entries={yesNoOptions(t)} parse={parseBoolean} inline disabled={isReadOnly} {...colSize} />
						<Field name='aerobicExercise_3' component={Input} horizontal label={t('AerobicExercise_3')} parse={value => value && Number(value)} disabled={isReadOnly} {...colSize} validate={validators.number} />
						<Field name='aerobicExercise_4' component={Input} horizontal label={t('AerobicExercise_4')} parse={value => value && Number(value)} disabled={isReadOnly} {...colSize} validate={validators.number} />
						<Row>
							<Col sm={6}>
								<Field name='aerobicExerciseLevel' component={Input} horizontal type='text' label={t('Level')} {...totalColSize} disabled />
							</Col>
						</Row>
					</Panel.Body>
				</Panel>
				<Panel>
					<Panel.Heading>{t('PostrotatoryNystagmus')}</Panel.Heading>
					<Panel.Body>
						{postrotatoryNystagmus}
						<Field name='postrotatoryNystagmus_6' component={Input} horizontal label={t('PostrotatoryNystagmus_6')} parse={value => value && Number(value)} disabled={isReadOnly} {...colSize} validate={validators.number} />
						<Row>
							<Col sm={6}>
								<Field name='postrotatoryNystagmusLevel' component={Input} horizontal type='text' label={t('Level')} {...totalColSize} disabled />
							</Col>
						</Row>
					</Panel.Body>
				</Panel>

			</Form>
		);
	}
}

const mapStateToProps = (state, ownProps) => {
	const {
		entities: { children }
	} = state;

	return {
		child: children[ownProps.childId]
	};
};

export default connect(mapStateToProps, {
	fetchChildDetails
})(withResourcesNamespace(props => props.resourcesNamespace)(CoreStabilityAssessment));

export const RequiredFields = [

];

const bridgePositionLevels = [
	{ level: 15, field: 'bridgePosition_12', minValue: 60 },
	{ level: 14, field: 'bridgePosition_11', minValue: 60 },
	{ level: 13, field: 'bridgePosition_11', minValue: 30 },
	{ level: 12, field: 'bridgePosition_10', minValue: 60 },
	{ level: 11, field: 'bridgePosition_9', minValue: 60 },
	{ level: 10, field: 'bridgePosition_8', minValue: 60 },
	{ level: 9, field: 'bridgePosition_7', minValue: 60 },
	{ level: 8, field: 'bridgePosition_6', minValue: 30 },
	{ level: 7, field: 'bridgePosition_5', minValue: 30 },
	{ level: 6, field: 'bridgePosition_4', minValue: 30 },
	{ level: 5, field: 'bridgePosition_3', minValue: 30 },
	{ level: 4, field: 'bridgePosition_2', minValue: 60 },
	{ level: 3, field: 'bridgePosition_1', minValue: 60 },
	{ level: 2, field: 'bridgePosition_1', minValue: 30 },
	{ level: 1, field: 'bridgePosition_1', minValue: 10 }
];

const curlUpsLevels = [
	{ level: 15, field: 'curlUps_2', minValue: 51 },
	{ level: 14, field: 'curlUps_2', minValue: 46 },
	{ level: 13, field: 'curlUps_2', minValue: 41 },
	{ level: 12, field: 'curlUps_2', minValue: 36 },
	{ level: 11, field: 'curlUps_2', minValue: 31 },
	{ level: 10, field: 'curlUps_2', minValue: 26 },
	{ level: 9, field: 'curlUps_2', minValue: 21 },
	{ level: 8, field: 'curlUps_2', minValue: 16 },
	{ level: 7, field: 'curlUps_2', minValue: 11 },
	{ level: 6, field: 'curlUps_2', minValue: 9 },
	{ level: 5, field: 'curlUps_2', minValue: 6 },
	{ level: 4, field: 'curlUps_2', minValue: 2 },
	{ level: 3, field: 'curlUps_2', minValue: 1 },
	{ level: 2, field: 'curlUps_1', minValue: 2 },
	{ level: 1, field: 'curlUps_1', minValue: 1 }
];

const lateralCoreLevels = [
	{ level: 15, field: 'lateralCore_6', minValue: 60 },
	{ level: 14, field: 'lateralCore_6', minValue: 30 },
	{ level: 13, field: 'lateralCore_5', minValue: 60 },
	{ level: 12, field: 'lateralCore_5', minValue: 30 },
	{ level: 11, field: 'lateralCore_4', minValue: 60 },
	{ level: 10, field: 'lateralCore_4', minValue: 30 },
	{ level: 9, field: 'lateralCore_3', minValue: 60 },
	{ level: 8, field: 'lateralCore_3', minValue: 30 },
	{ level: 7, field: 'lateralCore_2', minValue: 60 },
	{ level: 6, field: 'lateralCore_2', minValue: 30 },
	{ level: 5, field: 'lateralCore_2', minValue: 15 },
	{ level: 4, field: 'lateralCore_2', minValue: 5 },
	{ level: 3, field: 'lateralCore_1', minValue: 30 },
	{ level: 2, field: 'lateralCore_1', minValue: 15 },
	{ level: 1, field: 'lateralCore_1', minValue: 5 } //????
];

const proneCoreLevels = [
	{ level: 15, field: 'proneCore_11', minValue: 60 },
	{ level: 14, field: 'proneCore_10', minValue: 60 },
	{ level: 13, field: 'proneCore_9', minValue: 60 },
	{ level: 12, field: 'proneCore_8', minValue: 60 },
	{ level: 11, field: 'proneCore_7', minValue: 60 },
	{ level: 10, field: 'proneCore_6', minValue: 60 },
	{ level: 9, field: 'proneCore_6', minValue: 30 },
	{ level: 8, field: 'proneCore_6', minValue: 15 },
	{ level: 7, field: 'proneCore_5', minValue: 60 },
	{ level: 6, field: 'proneCore_5', minValue: 30 },
	{ level: 5, field: 'proneCore_4', minValue: 15 },
	{ level: 4, field: 'proneCore_3', minValue: 15 },
	{ level: 3, field: 'proneCore_2', minValue: 15 },
	{ level: 2, field: 'proneCore_1', minValue: 15 },
	{ level: 1, field: 'proneCore_1', minValue: 5 }
];

const pushUpsBoyLevels = [
	{ level: 15, field: 'pushUps_2', minValue: 40 },
	{ level: 14, field: 'pushUps_2', minValue: 35 },
	{ level: 13, field: 'pushUps_2', minValue: 30 },
	{ level: 12, field: 'pushUps_2', minValue: 25 },
	{ level: 11, field: 'pushUps_2', minValue: 20 },
	{ level: 10, field: 'pushUps_2', minValue: 18 },
	{ level: 9, field: 'pushUps_2', minValue: 15 },
	{ level: 8, field: 'pushUps_2', minValue: 12 },
	{ level: 7, field: 'pushUps_2', minValue: 10 },
	{ level: 6, field: 'pushUps_2', minValue: 8 },
	{ level: 5, field: 'pushUps_2', minValue: 5 },
	{ level: 4, field: 'pushUps_1', minValue: 60 },
	{ level: 3, field: 'pushUps_1', minValue: 30 },
	{ level: 2, field: 'pushUps_1', minValue: 10 },
	{ level: 1, field: 'pushUps_1', minValue: 5 }
];

const pushUpsGirlLevels = [
	{ level: 15, field: 'pushUps_2', minValue: 27 },
	{ level: 14, field: 'pushUps_2', minValue: 25 },
	{ level: 13, field: 'pushUps_2', minValue: 23 },
	{ level: 12, field: 'pushUps_2', minValue: 21 },
	{ level: 11, field: 'pushUps_2', minValue: 19 },
	{ level: 10, field: 'pushUps_2', minValue: 17 },
	{ level: 9, field: 'pushUps_2', minValue: 15 },
	{ level: 8, field: 'pushUps_2', minValue: 12 },
	{ level: 7, field: 'pushUps_2', minValue: 10 },
	{ level: 6, field: 'pushUps_2', minValue: 8 },
	{ level: 5, field: 'pushUps_2', minValue: 5 },
	{ level: 4, field: 'pushUps_1', minValue: 60 },
	{ level: 3, field: 'pushUps_1', minValue: 30 },
	{ level: 2, field: 'pushUps_1', minValue: 10 },
	{ level: 1, field: 'pushUps_1', minValue: 5 }
];

const aerobicExerciseLevels = [
	{ level: 15, field: 'aerobicExercise_4', minValue: 80 },
	{ level: 14, field: 'aerobicExercise_4', minValue: 70 },
	{ level: 13, field: 'aerobicExercise_4', minValue: 60 },
	{ level: 12, field: 'aerobicExercise_4', minValue: 50 },
	{ level: 11, field: 'aerobicExercise_4', minValue: 40 },
	{ level: 10, field: 'aerobicExercise_4', minValue: 30 },
	{ level: 9, field: 'aerobicExercise_3', minValue: 60 },
	{ level: 8, field: 'aerobicExercise_3', minValue: 50 },
	{ level: 7, field: 'aerobicExercise_3', minValue: 40 },
	{ level: 6, field: 'aerobicExercise_3', minValue: 30 },
	{ level: 5, field: 'aerobicExercise_3', minValue: 20 },
	{ level: 4, field: 'aerobicExercise_3', minValue: 10 },
	{ level: 3, field: 'aerobicExercise_3', minValue: 5 },
	{ level: 2, field: 'aerobicExercise_2', minValue: 1 },
	{ level: 1, field: 'aerobicExercise_1', minValue: 1 }
];

const postrotatoryNystagmusLevels = [
	{ level: 15, field: 'postrotatoryNystagmus_6', calculateFunc: (value) => value === 9 },
	{ level: 14, field: 'postrotatoryNystagmus_6', calculateFunc: (value) => value === 8 || value === 10 },
	{ level: 13, field: 'postrotatoryNystagmus_6', calculateFunc: (value) => value === 7 || value === 11 },
	{ level: 12, field: 'postrotatoryNystagmus_6', calculateFunc: (value) => value === 6 || value === 12 },
	{ level: 11, field: 'postrotatoryNystagmus_6', calculateFunc: (value) => value === 5 || value === 13 },
	{ level: 10, field: 'postrotatoryNystagmus_6', calculateFunc: (value) => value === 4 || value === 14 },
	{ level: 9, field: 'postrotatoryNystagmus_6', calculateFunc: (value) => value === 3 || value === 15 },
	{ level: 8, field: 'postrotatoryNystagmus_6', calculateFunc: (value) => value === 2 || value === 16 },
	{ level: 7, field: 'postrotatoryNystagmus_6', calculateFunc: (value) => value === 1 || value === 17 },
	{ level: 6, field: 'postrotatoryNystagmus_6', calculateFunc: (value) => value != null && (value === 0 || value >= 18) },
	{ level: 5, field: 'postrotatoryNystagmus_5', calculateFunc: (value) => value },
	{ level: 4, field: 'postrotatoryNystagmus_4', calculateFunc: (value) => value },
	{ level: 3, field: 'postrotatoryNystagmus_3', calculateFunc: (value) => value },
	{ level: 2, field: 'postrotatoryNystagmus_2', calculateFunc: (value) => value },
	{ level: 1, field: 'postrotatoryNystagmus_1', calculateFunc: (value) => value }
];

const brachiationBoyLevels = [
	{ level: 15, field: 'brachiation_3', minValue: 35 },
	{ level: 14, field: 'brachiation_3', minValue: 30 },
	{ level: 13, field: 'brachiation_3', minValue: 25 },
	{ level: 12, field: 'brachiation_3', minValue: 20 },
	{ level: 11, field: 'brachiation_3', minValue: 14 },
	{ level: 10, field: 'brachiation_3', minValue: 13 },
	{ level: 9, field: 'brachiation_3', minValue: 12 },
	{ level: 8, field: 'brachiation_3', minValue: 11 },
	{ level: 7, field: 'brachiation_3', minValue: 10 },
	{ level: 6, field: 'brachiation_3', minValue: 9 },
	{ level: 5, field: 'brachiation_3', minValue: 8 },
	{ level: 4, field: 'brachiation_3', minValue: 6 },
	{ level: 3, field: 'brachiation_3', minValue: 1 },
	{ level: 2, field: 'brachiation_2', minValue: 1 },
	{ level: 1, field: 'brachiation_1', minValue: 1 }
];

const brachiationGirlLevels = [
	{ level: 15, field: 'brachiation_3', minValue: 16 },
	{ level: 14, field: 'brachiation_3', minValue: 15 },
	{ level: 13, field: 'brachiation_3', minValue: 14 },
	{ level: 12, field: 'brachiation_3', minValue: 13 },
	{ level: 11, field: 'brachiation_3', minValue: 12 },
	{ level: 10, field: 'brachiation_3', minValue: 11 },
	{ level: 9, field: 'brachiation_3', minValue: 10 },
	{ level: 8, field: 'brachiation_3', minValue: 9 },
	{ level: 7, field: 'brachiation_3', minValue: 8 },
	{ level: 6, field: 'brachiation_3', minValue: 7 },
	{ level: 5, field: 'brachiation_3', minValue: 6 },
	{ level: 4, field: 'brachiation_3', minValue: 5 },
	{ level: 3, field: 'brachiation_3', minValue: 1 },
	{ level: 2, field: 'brachiation_2', minValue: 1 },
	{ level: 1, field: 'brachiation_1', minValue: 1 }
];

export const ValidationFunc = (values, t) => {
	let errors = {};

	if (values.pushUpsLevel === 'N/A') {
		errors['pushUpsLevel'] = t('IndividualConsultationForm_Child_Gender_Required');
	}
	if (values.brachiationLevel === 'N/A') {
		errors['brachiationLevel'] = t('IndividualConsultationForm_Child_Gender_Required');
	}
	return errors;
};

